module.exports = __webpack_public_path__ + "static/media/Farma pasa - Ekspresija (f1).07a73b73.mp3";